
import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <header className="old-site-header">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="/lovable-uploads/62e55e12-a6b7-4346-9c31-f9ad20c8b1b6.png" 
                alt="allunitcalculators.com logo" 
                className="h-20 w-auto max-w-none"
                style={{ height: '5rem', display: 'block' }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  console.log('Logo failed to load:', target.src);
                  target.style.backgroundColor = '#ff0000';
                  target.style.width = '200px';
                  target.style.height = '5rem';
                }}
                onLoad={() => console.log('Logo loaded successfully')}
              />
            </Link>
          </div>
          <nav className="hidden md:flex space-x-6 text-sm">
            <Link to="/calculators" className="font-bold text-white/90 hover:text-white transition-colors">
              Calculators
            </Link>
            <Link to="/converters" className="font-bold text-white/90 hover:text-white transition-colors">
              Converters
            </Link>
            <Link to="/special" className="font-bold text-white/90 hover:text-white transition-colors">
              Special Tools
            </Link>
            <Link to="/blog" className="font-bold text-white/90 hover:text-white transition-colors">
              Blog
            </Link>
            <Link to="/sitemap" className="font-bold text-white/90 hover:text-white transition-colors">
              Sitemap
            </Link>
          </nav>
          <div className="md:hidden">
            <button className="text-white">
              Menu
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
